<template>
  <main role="main" class="col content-spacing">
    <b-card-group deck style="margin-top: 20px">
      <b-card title="Usuários Recentes">
        <loading-list v-if="viewData.pending.loading"></loading-list>
        <b-list-group
          v-if="!viewData.pending.loading && viewData.pending.list.length > 0"
        >
          <b-list-group-item
            v-for="item in viewData.pending.list"
            :key="item.id"
          >
            <b-badge style="margin-right: 10px" variant="info">{{
              formatCalendar(item.createdAt)
            }}</b-badge>
            <a :href="`/#/user/edit/${item.id}/${item.accountProfile}`">{{
              item.name
            }}</a>
            <b-badge variant="light">{{ item.socialNumber }}</b-badge>
            <b-icon
              style="float: right"
              v-if="item.loading"
              icon="arrow-clockwise"
              animation="spin"
              font-scale="2"
            ></b-icon>
<!--             <b-form-checkbox
              style="float: right"
              switch
              v-else
              @change="() => setStatus(item)"
              size="lg"
              v-model="item.approved"
            ></b-form-checkbox> -->
          </b-list-group-item>
        </b-list-group>
        <empty-list
          v-else-if="
            !viewData.pending.loading && viewData.pending.list.length === 0
          "
        ></empty-list>
        <template
          v-slot:footer
          v-if="!viewData.pending.loading && viewData.pending.list.length > 0"
        >
          <small class="text-muted">{{
            getLastUpdate(viewData.pending.list)
          }}</small>
        </template>
      </b-card>
      <b-card title="Cadastros pendentes">
        <loading-list v-if="viewData.pendingRegisters.loading"></loading-list>
        <b-list-group
          v-if="
            !viewData.pendingRegisters.loading &&
            viewData.pendingRegisters.list.length > 0
          "
        >
          <b-list-group-item
            v-for="item in viewData.pendingRegisters.list"
            :key="item.id"
          >
            <a :href="`/#/user/view/${item.id}/consumer`">{{ item.name }}</a>
            <b-badge variant="light">{{ item.socialNumber }}</b-badge>
          </b-list-group-item>
        </b-list-group>
        <empty-list
          v-else-if="
            !viewData.pendingRegisters.loading &&
            viewData.pendingRegisters.list.length === 0
          "
        ></empty-list>
      </b-card>
    </b-card-group>
    <b-card-group deck style="margin-top: 10px">
      <b-card title="Últimas Instalações">
        <loading-list v-if="viewData.installation.loading"></loading-list>
        <b-list-group
          v-if="
            !viewData.installation.loading &&
            viewData.installation.list.length > 0
          "
        >
          <b-list-group-item
            v-for="item in viewData.installation.list"
            :key="item.id"
          >
            <b-badge style="margin-right: 10px" variant="info">{{
              formatCalendar(item.createdAt)
            }}</b-badge>
            <a :href="`/#/installation/edit/${item.id}`">
              <b-badge variant="light"
                >{{ item.installationNumber }} - {{ item.address }} -
                {{ item.state }}</b-badge
              >
            </a>
          </b-list-group-item>
        </b-list-group>

        <empty-list
          v-else-if="
            !viewData.installation.loading &&
            viewData.installation.list.length === 0
          "
        ></empty-list>

        <template
          v-slot:footer
          v-if="
            !viewData.installation.loading &&
            viewData.installation.list.length > 0
          "
        >
          <small class="text-muted">{{
            getLastUpdate(viewData.installation.list)
          }}</small>
        </template>
      </b-card>

      <b-card title="Últimas Faturas">
        <loading-list v-if="viewData.billing.loading"></loading-list>
        <b-list-group
          v-if="!viewData.billing.loading && viewData.billing.list.length > 0"
        >
          <b-list-group-item
            v-for="item in viewData.billing.list"
            :key="item.id"
          >
            <b-badge style="margin-right: 10px" variant="info">{{
              formatCalendar(item.createdAt)
            }}</b-badge>
            <!-- <a :href="`/#/installation/${item.installation}/billings`">
              <b-badge variant="light">{{item.value | currency}} - {{item.installationAddres}} - {{item.status}}</b-badge>
            </a>-->
            <b-badge variant="light"
              >{{ item.value | currency }} - {{ item.installationAddres }} -
              {{ getStatusName(item.status) }}</b-badge
            >
          </b-list-group-item>
        </b-list-group>

        <empty-list
          v-else-if="
            !viewData.billing.loading && viewData.billing.list.length === 0
          "
        ></empty-list>

        <template
          v-slot:footer
          v-if="!viewData.billing.loading && viewData.billing.list.length > 0"
        >
          <small class="text-muted">{{
            getLastUpdate(viewData.billing.list)
          }}</small>
        </template>
      </b-card>
      <b-card title="Últimas Notas Fiscais">
        <loading-list v-if="viewData.invoice.loading"></loading-list>
        <b-list-group
          v-if="!viewData.invoice.loading && viewData.invoice.list.length > 0"
        >
          <b-list-group-item
            v-for="item in viewData.invoice.list"
            :key="item.id"
          >
            <b-badge style="margin-right: 10px" variant="info">{{
              formatCalendar(item.createdAt)
            }}</b-badge>
            <a :href="item.url">{{ item.description.substring(0, 100) }}</a>
            <a :href="`/#/user/${item.userId}/invoices`">
              <b-badge variant="light">{{ item.userName }}</b-badge>
            </a>
          </b-list-group-item>
        </b-list-group>

        <empty-list
          v-else-if="
            !viewData.invoice.loading && viewData.invoice.list.length === 0
          "
        ></empty-list>

        <template
          v-slot:footer
          v-if="!viewData.invoice.loading && viewData.invoice.list.length > 0"
        >
          <small class="text-muted">{{
            getLastUpdate(viewData.invoice.list)
          }}</small>
        </template>
      </b-card>
    </b-card-group>
  </main>
</template>

<script>
import moment from 'moment-timezone';
import * as _ from 'lodash';
import Vue from 'vue';

import helpers from '../vue/helpers';
import { Api } from '../vue/api';

const API = new Api();

export default {
  name: 'dashboard',
  data: function () {
    return {
      state: {},
      viewData: {
        pending: {
          loading: true,
          list: [],
        },
        pendingRegisters: {
          loading: true,
          list: [],
        },
        installation: {
          loading: true,
          list: [],
        },
        billing: {
          loading: true,
          list: [],
        },
        invoice: {
          loading: true,
          list: [],
        },
      },
    };
  },
  computed: {},
  beforeMount: async function () {
    moment.locale('pt-BR');

    this.getPendingUsers();
    this.getPendingRegisters();
    this.getLastInstallations();
    this.getLastBillings();
    this.getLastInvoices();
  },
  methods: {
    getStatusName(status) {
      if (status === 'open') {
        return 'Em aberto';
      } else if (status === 'pending') {
        return 'Pendente';
      } else {
        return 'Paga';
      }
    },
    formatDate(date) {
      if (!date) return '';

      let mDate = moment(date);
      return `Última atualização: ${mDate.fromNow()} (${mDate.format(
        'DD/MM/YYYY HH:mm',
      )})`;
    },
    formatCalendar(date) {
      if (!date) return '';

      return moment(date).fromNow();
    },
    getLastUpdate(list) {
      if (list && list.length) {
        return this.formatDate(list[0].updatedAt || list[0].createdAt);
      }
    },
    async setStatus(item) {
      const index = this.viewData.pending.list.indexOf(item);

      item.loading = true;

      try {
        const result = await API.post('/execute', {
          path: `/user/${item.id}/status/${!item.approved}`,
          method: 'put',
        });
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      item.loading = false;
      Vue.set(this.viewData.pending.list, index, item);
    },
    async getLastInvoices() {
      this.viewData.invoice.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/last-invoices',
          method: 'get',
        });

        this.viewData.invoice.list = result.model;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.invoice.loading = false;
    },
    async getPendingUsers() {
      this.viewData.pending.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/users?showPending=true&showOnlyPending=true',
          method: 'get',
        });

        this.viewData.pending.list = result.model.list;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.pending.loading = false;
    },
    async getPendingRegisters() {
      this.viewData.pendingRegisters.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/consumers-recent',
          method: 'get',
        });

        this.viewData.pendingRegisters.list = result.model.list;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.pendingRegisters.loading = false;
    },

    async getLastInstallations() {
      this.viewData.installation.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/last-installations',
          method: 'get',
        });

        this.viewData.installation.list = result.model;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.installation.loading = false;
    },
    async getLastBillings() {
      this.viewData.billing.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/last-billings',
          method: 'get',
        });

        this.viewData.billing.list = result.model;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.billing.loading = false;
    },
  },
  components: {},
};
</script>


</script>